
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/klatpension",
      function () {
        return require("private-next-pages/klatpension/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/klatpension"])
      });
    }
  